<template>
  <div class="d-flex align-center">
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-icon
          :color="iconData(change.type).color"
          class="mr-1"
          size="20"
          v-on="on"
          v-text="iconData(change.type).name"
        />
      </template>
      <span class="smalll">Data {{ iconData(change.type).label }}</span>
    </v-tooltip>
    <div>
      <template v-if="change.context">
        <span class="blue--text">[{{ change.context }}]</span>
        <span>: </span>
      </template>
      <span>{{ change.value == undefined ? 'unset'.toUpperCase() : change.value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiffItem',
  props: {
    change: {
      type: Object,
      required: true,
    },
  },
  methods: {
    iconData(type) {
      switch (type) {
        case 'add':
          return { name: 'add', label: 'added', color: 'success' }
        case 'delete':
          return { name: 'remove', label: 'removed', color: 'error' }
        case 'edit':
        default:
          return { name: 'compare_arrows', label: 'modified', color: 'warning' }
      }
    },
  },
}
</script>
